<template>
  <div class="text-dark d-flex">
    <!-- Slot for word in front of search result -->
    <div class="mr-2">Results:</div>
    <div>
      <!-- Keywords from search bar -->
      <div v-if="extractSearchKeywords">
        {{ extractSearchKeywords }}
      </div>
      <!-- Filter from Modal-date-time -->
      <div v-if="filterDateTime.start">
        Start after
        {{ formatedDatetime(filterDateTime.start, 'MMM DD, YYYY HH:mma') }}
        {{ cityTimezone }} time
        <span v-if="filterDateTime.end"
          >End By
          {{ formatedDatetime(filterDateTime.end, 'MMM DD, YYYY HH:mma') }}
          {{ cityTimezone }} time</span
        >
      </div>
      <!-- Filter from Modal-categories -->
      <div v-if="filterCategories.length">
        <div
          v-for="(category, $index) in filterCategories"
          :key="`${category.id}__${category.name}`"
          class="d-inline"
        >
          {{ category.name }}
          <div v-if="$index !== filterCategories.length - 1" class="d-inline ml-0">,</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Mixins */
import { datetimeMixin } from '@/mixins';

export default {
  name: 'SearchResults',

  // filters: {
  //   /**
  //    * filter ISO format to date format
  //    *
  //    * @return {String} (ex. MM DD, YYYY)
  //    */
  //   ISOtoDate(ISO) {
  //     /**
  //      * document for format string "https://day.js.org/docs/en/parse/string-format"
  //      *
  //      * ex. format 2020-09-01T00:00:00+07:00 to Sep 01, 2020 00:00am
  //      */

  //     return moment(`${ISO}`).format(`MMM DD, YYYY HH:mma`);
  //   },
  // },

  mixins: [datetimeMixin],

  props: {
    extractSearchKeywords: {
      type: String,
      default: ''
    },
    /**
     * Date and Time for filter LUs
     *
     * @type {Object}
     */
    filterDateTime: {
      type: Object,
      default: () => ({
        start: null,
        end: null
      })
    },

    /**
     * Set of category for filter
     */
    filterCategories: {
      type: [Object, Array],
      default: () => []
    }
  },

  computed: {
    // timezone() {
    //   return Intl.DateTimeFormat().resolvedOptions().timeZone;
    // },
    currentPage() {
      return this.$route.name;
    }
  }
};
</script>
